module.exports = __webpack_public_path__ + "img/aviso.5845371a.jpeg";